import React from 'react';
import { Info } from 'lucide-react';

/**
 * F, option 2 — the informational note for a comparable much bigger or smaller than
 * the subject. Amber and quiet on purpose: the value is already adjusted for size and
 * the confidence is NOT lowered; the user is told what the comparison leaned on. The
 * red alert (UserCompOutlierAlert) is for a PRICE outlier — a different thing.
 */
const UserCompSizeNote = ({ notes = [], lang = 'en' }) => {
  if (!notes.length) return null;
  return (
    <div
      className="mb-4 sm:mb-6 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 flex items-start gap-2.5"
      data-testid="user-comp-size-note"
    >
      <Info className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
      <div className="text-sm text-amber-900">
        <span className="font-semibold">{lang === 'es' ? 'Nota de tamaño: ' : 'Size note: '}</span>
        {notes.map((n, i) => (
          <span key={n.address} data-testid="user-comp-size-note-item">
            {lang === 'es' ? (n.message_es || n.message) : (n.message_en || n.message)}{i < notes.length - 1 ? ' ' : ''}
          </span>
        ))}
      </div>
    </div>
  );
};

export default UserCompSizeNote;
